import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";

const navItems = [
  { to: "about", label: "Accueil" },
  { to: "service", label: "Services" },
  { to: "projets", label: "Projets" },
  { to: "cv", label: "Parcours" },
  { to: "competences", label: "Competences" },
];

export default function Header() {
  const [activeSection, setActiveSection] = useState("about");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section[id]");
      let currentSection = "about";

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 130;
        if (window.scrollY >= sectionTop) {
          currentSection = section.getAttribute("id");
        }
      });

      setActiveSection(currentSection);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="site-header">
      <nav className="site-nav">
        <a href="mailto:abdoubachabikowiyou@gmail.com" className="brand" aria-label="Contacter Abdou">
          <span className="brand-name">Abdou Kowiyou</span>
          <span className="brand-role">Full-stack / Pentest</span>
        </a>

        <button
          type="button"
          className="menu-toggle"
          aria-label="Ouvrir le menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((current) => !current)}
        >
          <i className={isOpen ? "fa-solid fa-xmark" : "fa-solid fa-bars"}></i>
        </button>

        <div className={`nav-links ${isOpen ? "open" : ""}`}>
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              smooth
              duration={600}
              offset={-90}
              className={activeSection === item.to ? "active" : ""}
              onClick={() => setIsOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="contact"
            smooth
            duration={600}
            offset={-90}
            className={`hire-link ${activeSection === "contact" ? "active" : ""}`}
            onClick={() => setIsOpen(false)}
          >
            Engagez-moi
          </Link>
        </div>
      </nav>
    </header>
  );
}
